export const CRYPTO_VERSION = 1 as const;
export const PLAINTEXT_SCHEMA_VERSION = 1 as const;
export const ARGON2ID_PARAMETERS = Object.freeze({
  algorithm: 'argon2id' as const,
  memoryKiB: 65_536 as const,
  iterations: 3 as const,
  parallelism: 4 as const,
  outputBytes: 32 as const,
});
export const ATTACHMENT_PLAINTEXT_BLOCK_BYTES = 4 * 1024 * 1024;
export const MAX_ATTACHMENT_BYTES = 100 * 1024 * 1024;

export type EntityType = 'hold' | 'collection' | 'group' | 'comment' | 'annotation' | 'memberProfile';

export interface AccountBundleV1 {
  schemaVersion: 1;
  keyRevision: number;
  accountRootKey: string;
  encryptionPrivateKey: string;
  encryptionPublicKey: string;
  signingPrivateKey: string;
  signingPublicKey: string;
}

export interface Argon2idParametersV1 {
  algorithm: 'argon2id'; memoryKiB: 65536; iterations: 3; parallelism: 4; outputBytes: 32; salt: string;
}

export interface WrappedKeyBundleV1 {
  cryptoVersion: 1;
  keyRevision: number;
  wrapType: 'passphrase' | 'recovery';
  kdf?: Argon2idParametersV1;
  nonce: string;
  ciphertext: string;
}

export interface CryptoProfileCreateV1 {
  cryptoVersion: 1;
  keyRevision: number;
  encryptionPublicKey: string;
  signingPublicKey: string;
  fingerprint: string;
  passphraseBundle: WrappedKeyBundleV1;
  recoveryBundle: WrappedKeyBundleV1;
}

export interface EncryptedEntityV1 {
  cryptoVersion: 1;
  entityType: EntityType;
  entityID: string;
  ownerID: string;
  revision: number;
  plaintextSchemaVersion: 1;
  createdAt: string;
  nonce: string;
  ciphertext: string;
  signerUserID: string;
  signerKeyRevision: number;
  signature: string;
}

export interface KeyEnvelopeV1 {
  cryptoVersion: 1;
  keyEnvelopeID: string;
  entityID: string;
  recipientID: string;
  recipientType: 'owner' | 'group';
  groupEpoch?: number | null;
  algorithm: 'hpke-p256-sha256-aes256gcm' | 'aes256gcm';
  encapsulatedKey?: string | null;
  nonce?: string | null;
  ciphertext: string;
  senderID: string;
  senderKeyRevision: number;
  signature: string;
}

export interface GroupKeyGrantV1 {
  cryptoVersion: 1; grantID: string; groupID: string; epoch: number; recipientID: string;
  encapsulatedKey: string; ciphertext: string; creatorID: string; creatorKeyRevision: number; signature: string;
}

export interface JoinCardV1 {
  cryptoVersion: 1; joinCardID: string; groupID: string; applicantID: string; approverID: string;
  encapsulatedKey: string; ciphertext: string; signerKeyRevision: number; signature: string;
}

export interface AttachmentManifestV1 {
  cryptoVersion: 1; attachmentID: string; holdID: string; ownerID: string; uploadRevision: number;
  blockCount: number; ciphertextBytes: number; noncePrefix: string; blockDigests: string[];
  signerUserID: string; signerKeyRevision: number; signature: string;
}

export interface PublicKeysV1 {
  userID: string; keyRevision: number; encryptionPublicKey: string; signingPublicKey: string; fingerprint: string;
}

export interface DeviceBundleRecordV1 {
  cryptoVersion: 1; userID: string; keyRevision: number; nonce: string; ciphertext: string; fingerprint: string;
}
